import {sameText,fieldValue,patchField} from "./safeActions";
const cents=n=>Math.round(Number(n)*100);
const same=(a,b)=>String(a??"")===String(b??"");
export async function previewSafeCommand(api,command){
 if(command.type==="site"){
  const r=await api.get("/admin/site-settings");
  const before=fieldValue(r.data.config,command.path);
  if(before===undefined)throw new Error("Campo não disponível na configuração do site.");
  if(same(before,command.value))throw new Error("Este campo já possui esse texto.");
  return {...command,before,summary:command.label+": "+String(before)+" → "+command.value};
 }
 if(command.type==="price"){
  const r=await api.get("/admin/products/all");
  const matches=r.data.filter(p=>sameText(p.name,command.productName)&&p.active!==false);
  if(matches.length!==1)throw new Error(matches.length?"Nome ambíguo; informe o produto exato.":"Produto não encontrado. Confira o nome exato no catálogo.");
  const product=matches[0],targetBox=cents(command.unit==="frasco"?command.value*10:command.value)/100;
  if(cents(product.price)===cents(targetBox))throw new Error("O produto já possui esse preço.");
  return {...command,id:product.id,productName:product.name,before:Number(product.price),targetBox,
   summary:product.name+": BOX de 10 frascos R$ "+Number(product.price).toFixed(2)+" → R$ "+targetBox.toFixed(2)+" (R$ "+(targetBox/10).toFixed(2)+" por frasco)"};
 }
 throw new Error("Comando não autorizado.");
}
export async function applySafeProposal(api,plan){
 if(plan.type==="site"){
  const current=(await api.get("/admin/site-settings")).data.config;
  if(!same(fieldValue(current,plan.path),plan.before))throw new Error("Outro administrador alterou este campo. Refaça a prévia.");
  await api.put("/admin/site-settings",{config:patchField(current,plan.path,plan.value)});
  const value=fieldValue((await api.get("/admin/site-settings")).data.config,plan.path);
  if(!same(value,plan.value))throw new Error("A gravação foi enviada, mas a conferência não confirmou o novo valor. Consulte a Personalização do Site antes de tentar novamente.");
  return {type:"site",path:plan.path,oldValue:plan.before,newValue:value,label:plan.label};
 }
 if(plan.type==="price"){
  const list=(await api.get("/admin/products/all")).data;
  const product=list.find(p=>p.id===plan.id);
  if(!product||cents(product.price)!==cents(plan.before))throw new Error("O produto foi alterado depois da prévia. Refaça a consulta.");
  await api.patch("/admin/products/"+encodeURIComponent(plan.id),{price:plan.targetBox});
  const fresh=(await api.get("/admin/products/all")).data.find(p=>p.id===plan.id);
  if(!fresh||cents(fresh.price)!==cents(plan.targetBox))throw new Error("Alteração enviada, mas não confirmada. Confira o produto antes de repetir.");
  return {type:"price",id:plan.id,oldValue:plan.before,newValue:plan.targetBox,label:plan.productName};
 }
 throw new Error("Ação não autorizada.");
}
export async function undoSafeAction(api,action){
 if(action.type==="site"){
  const current=(await api.get("/admin/site-settings")).data.config;
  if(!same(fieldValue(current,action.path),action.newValue))throw new Error("Este campo já mudou novamente; não é seguro desfazer automaticamente.");
  await api.put("/admin/site-settings",{config:patchField(current,action.path,action.oldValue)});
  const check=fieldValue((await api.get("/admin/site-settings")).data.config,action.path);
  if(!same(check,action.oldValue))throw new Error("Reversão enviada, mas não confirmada. Confira o painel.");
  return;
 }
 if(action.type==="price"){
  const current=(await api.get("/admin/products/all")).data.find(p=>p.id===action.id);
  if(!current||cents(current.price)!==cents(action.newValue))throw new Error("O preço já mudou novamente; não é seguro desfazer automaticamente.");
  await api.patch("/admin/products/"+encodeURIComponent(action.id),{price:action.oldValue});
  const check=(await api.get("/admin/products/all")).data.find(p=>p.id===action.id);
  if(!check||cents(check.price)!==cents(action.oldValue))throw new Error("Reversão enviada, mas não confirmada. Confira o produto.");
  return;
 }
 throw new Error("Reversão não autorizada.");
}
